import React, { useRef } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Table,
  TableBody,
  Tooltip,
} from "@mui/material";
import { FaPrint } from "react-icons/fa";

import { convertDate } from "../../utils";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    background: "rgb(255, 255, 255)",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const UserDetailPopUp = ({
  userDetial,
  setUserDetial,
  userDetialPopUp,
  setUserDetialPopUp,
  index,

  renderInfoItem,
}) => {
  const oldDom = useRef();

  return (
    <StyledDialog
      open={userDetialPopUp}
      onClose={() => {
        setUserDetial({});
        setUserDetialPopUp(false);
      }}
      fullWidth
      maxWidth="md"
    >
      <DialogContent style={{ padding: "0px" }}>
        <Grid
          container
          className={`printBox${index}`}
          flexDirection="column"
          padding={{ xs: "0px", sm: "0px", md: "0px" }}
          sx={{ height: "100%" }}
        >
          <Grid
            item
            container
            sx={{
              height: "100%",
              position: "relative",
              borderRadius: "12.5px",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              justifyContent: "center",
            }}
          >
            <Grid item container padding="20px">
              <Grid item xs={11}>
                <Typography
                  variant="h5"
                  sx={{
                    textAlign: "center",
                    fontWeight: "bolder",
                    "-webkit-text-stroke-width": ".5px",
                  }}
                >
                  User Details
                </Typography>
              </Grid>
              <Grid item xs={1} sx={{ alignContent: "end" }}>
                <Tooltip title="Print Card">
                  <FaPrint
                    onClick={() => {
                      oldDom.current = document.body.innerHTML;
                      const printContents = document.getElementsByClassName(
                        `printBox${index}`
                      )[0].innerHTML;
                      document.body.innerHTML = printContents;
                      window.print();
                      document.body.innerHTML = oldDom.current;
                    }}
                  />
                </Tooltip>
              </Grid>
            </Grid>

            <Grid item sx={{ width: "100%" }} padding="0px 20px 20px">
              <Grid
                item
                container
                justifyContent="center"
                flexDirection={"column"}
                sx={{ overflow: "hidden" }}
              >
                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    alignContent: "center",
                    justifyContent: "space-between",
                    textAlign: { xs: "center", sm: "start" },
                  }}
                >
                  <Grid item xs={12}>
                    <Table>
                      <TableBody>
                        {renderInfoItem(
                          "Name",
                          userDetial?.visitor_info?.first_name || "No Data"
                        )}
                        {renderInfoItem(
                          "Phone Number",
                          userDetial?.visitor_info?.phone_number || "No Data"
                        )}
                        {renderInfoItem(
                          "Email ID",
                          userDetial?.visitor_info?.email_id || "No Data"
                        )}
                      </TableBody>
                    </Table>
                  </Grid>

                  {Boolean(
                    userDetial?.journey_status?.qr_link &&
                      !userDetial?.journey_status?.send_consent
                  ) && (
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        justifyContent:
                          !userDetial?.journey_status.data_qr_link && "center",
                        border: "1px solid rgb(232, 222, 207)",
                        borderRadius: "12.5px",
                        overflowY: "scroll",
                        scrollbarWidth: "none",
                        flexDirection: "row",
                        padding: "10px 5px !important",
                      }}
                      xs={12}
                    >
                      <img
                        src={userDetial?.journey_status?.qr_link}
                        className="QrCodeImage"
                        style={{ margin: "0px 20px", height: "80px" }}
                      />
                      {userDetial?.journey_status.data_qr_link && (
                        <img
                          src={userDetial?.journey_status.data_qr_link}
                          className="QrCodeImage"
                          style={{ margin: "0px 20px", height: "80px" }}
                        />
                      )}
                    </Grid>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{ textAlign: { xs: "center", sm: "start" } }}
                >
                  <Table>
                    <TableBody>
                      {renderInfoItem(
                        "Booking ID",
                        userDetial?.gate_pass_id || "No Data"
                      )}
                      {renderInfoItem(
                        "Valid Till",
                        convertDate(userDetial?.valid_till) || "No Data"
                      )}
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </StyledDialog>
  );
};

export default UserDetailPopUp;
